export default () => {
    'use strict';
    const resourceCardsLinkedToModals = document.querySelectorAll(".card-footer [data-bs-toggle='modal']");

    resourceCardsLinkedToModals.forEach(card => {
        const modalId = card.getAttribute("data-bs-target");
        const modal = document.querySelector(modalId) as HTMLElement;

        if (modal) {
            modal.addEventListener("hidden.bs.modal", () => {
                setTimeout(() => {
                    (card as HTMLButtonElement).blur();
                }, 10);
            });
        }
    });
};
